export default "__VITE_ASSET__CCzXmwra__"